export default {
  loadingUploadForm: false,
  cteUploadForm: {
    logisticProviderId: null,
    ctesFiles: null,
  },
  loadingUploadList: false,
  cteUploadList: [],
  cteUploadListTotal: 0,
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/cte-upload/store/states.js